import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { BorderRadius } from '../../../../enums/borderRadius'
import { Color } from '../../../../enums/color'
import { Themable } from '../../../../types/themable'
import { zIndex } from '../../../../utils/zIndex'
import { getHeaderPadding } from '../../utils/getHeaderPadding'

interface TableHeaderWrapperProps extends Themable {
  sticky?: boolean
}

export const TableHeaderWrapper = styled.div<TableHeaderWrapperProps>`
  /* hack to keep border consistent with table body on sticky overflow while preserving rounded corners */
  box-shadow: 0 -7px 0 1px ${({ theme }) => theme.ds.colors.base.background};
  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: ${zIndex.TableStickyHeader};
    `}
`

interface TableHeaderProps {
  bordered?: boolean
  expandable?: boolean
  noContent?: boolean
  selectable?: boolean
}

export const TableHeader = styled.header<TableHeaderProps>`
  align-items: center;
  height: 56px;
  /* hack to keep border consistent with table body on sticky overflow while preserving rounded corners */
  margin-right: -1px;
  margin-left: -1px;
  border: 1px solid ${Color.Grey200};
  border-top-left-radius: ${BorderRadius.R12};
  border-top-right-radius: ${BorderRadius.R12};
  position: relative;
  z-index: ${zIndex.TableHeader};
  background-color: ${Color.White};
  color: ${Color.Grey950};
  white-space: nowrap;
  ${({ expandable, selectable }) => getHeaderPadding(selectable, expandable)};

  ${({ noContent, bordered }) =>
    noContent &&
    !bordered &&
    css`
      border-top-left-radius: ${BorderRadius.R12};
      border-top-right-radius: ${BorderRadius.R12};
    `}
`
